import { render, staticRenderFns } from "./NewShoppingCartBackPR.vue?vue&type=template&id=b08a1e90&scoped=true&"
import script from "./NewShoppingCartBackPR.vue?vue&type=script&lang=js&"
export * from "./NewShoppingCartBackPR.vue?vue&type=script&lang=js&"
import style0 from "./NewShoppingCartBackPR.vue?vue&type=style&index=0&id=b08a1e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a1e90",
  null
  
)

export default component.exports